import { useState, useEffect } from 'react';
import { FaCookieBite } from 'react-icons/fa';

const CookieConsentPopup = () => {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const cookieConsent = localStorage.getItem('cookieConsent');
    
    // Only show the popup if no decision has been made yet
    if (cookieConsent === null) {
      // Small delay to ensure the popup doesn't appear immediately on page load
      const timer = setTimeout(() => {
        setShowConsent(true);
      }, 1000);
      
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowConsent(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowConsent(false);
  };

  if (!showConsent) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 px-4 py-3 bg-[#112D4E] shadow-lg transform transition-transform duration-500 ease-in-out">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="text-[#19BFB7] text-2xl">
              <FaCookieBite />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-white">We use cookies</h3>
              <p className="text-sm text-gray-300">
                We use cookies to enhance your experience, analyze site usage, and for marketing purposes.
              </p>
            </div>
          </div>
          
          <div className="flex flex-wrap gap-3">
            <button 
              onClick={handleDecline}
              className="px-4 py-2 text-sm border border-gray-400 rounded-full text-white hover:bg-gray-700 transition duration-300"
            >
              Decline
            </button>
            <button 
              onClick={handleAccept}
              className="px-4 py-2 text-sm bg-[#19BFB7] border-2 border-[#19BFB7] rounded-full text-white hover:bg-white hover:text-[#0f1d35] transition duration-300"
            >
              Accept All Cookies
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentPopup;